import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import StudyRoutinePost from "../../../components/study-routine-post"
import theme from "../../../theme"

const summary = [
  {
    stage: "Primary",
    rhythm: "15 to 25 minutes, 2 to 3 days a week",
    focus: "Observation, vocabulary, simple explanations, curiosity",
    habit: "Explain one idea using a drawing, labels, or a real example",
  },
  {
    stage: "Lower secondary",
    rhythm: "25 to 40 minutes, 3 to 4 days a week",
    focus: "Concepts, diagrams, experiments, definitions, short answers",
    habit: "Turn each topic into cause, effect, and evidence notes",
  },
  {
    stage: "Upper secondary",
    rhythm: "45 to 70 minutes, 4 to 5 days a week",
    focus: "Depth, calculations, practical skills, data, exam responses",
    habit: "Practise explaining processes without looking at notes",
  },
  {
    stage: "Exam block",
    rhythm: "Past questions plus active recall",
    focus: "Weak topics, command terms, diagrams, data interpretation",
    habit: "Review wrong answers by identifying the missing concept",
  },
]

const sections = [
  {
    title: "Primary: keep curiosity active",
    paragraphs: [
      "Primary science study should connect ideas to things students can observe: weather, plants, forces, materials, animals, light, and sound.",
      "Simple drawings, labelled diagrams, and spoken explanations help students turn curiosity into understanding.",
    ],
  },
  {
    title: "Lower secondary: organise concepts",
    paragraphs: [
      "Lower secondary students need clear topic notes, definitions, diagrams, and short-answer practice. A good routine turns each lesson into a few cause-and-effect statements.",
      "Experiments should not be remembered as steps only. Students should know the question, variables, evidence, and conclusion.",
    ],
  },
  {
    title: "Upper secondary: practise applying knowledge",
    paragraphs: [
      "Upper secondary science requires active recall, calculations where relevant, data interpretation, and exam-style responses. Students should practise explaining processes from memory.",
      "Diagrams are not decorations. Redrawing and labelling them is one of the fastest ways to reveal gaps in understanding.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a calendar for lesson review, vocabulary, diagrams, calculation practice, practical skills, active recall, and past questions.",
      "The strongest science routine links three things: concept, evidence, and explanation.",
    ],
  },
]

const ScienceStudyRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Science Study Plan by School Level"
        description="Plan science study routines for primary, lower secondary, upper secondary, and exam periods with concepts, diagrams, experiments, data, and active recall."
      />
      <StudyRoutinePost
        subject="Science"
        title="Science study routines for different school levels"
        intro="A strong science routine helps students move from remembering facts to explaining concepts, evidence, diagrams, and data clearly."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/chilly-husky-97"
        image="blog-science.png"
        imageAlt="Science study planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default ScienceStudyRoutines
